export const getRadioSelectedValue = (value?: boolean) => {
  if (value === undefined) return undefined;
  return value ? 'yes' : 'no';
};
